<template>
  <div style="margin-bottom:15px;">
    <a-form ref="formRef"
            :model="adjustData"
            name="basic"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 16 }"
            autocomplete="off">
      <a-form-item label="用户名"
                   name="username">
        <div>{{ adjustData.username }}</div>
      </a-form-item>
      <a-form-item label="调价率"
                   name="rate"
                   :rules="[{ required: true, message: '请为用户设置最高调价率' }]">
        <a-input-number v-model:value="adjustData.rate"
                        :min="minRate"
                        max="100"
                        :precision="0" />%
        <a-tooltip>
          <template #title>不能低于父用户的调价率：{{ minRate }}%</template>
          <QuestionCircleOutlined style="margin-left: 10px;" />
        </a-tooltip>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
        <a-button v-p="'/user/user_id/sale:POST'"
                  type="primary"
                  @click="addAdjust">保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue"
import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'
import { message } from "ant-design-vue"
import { useRbacStore } from '../../DefaultRbacPagePlugin'

const rbac = useRbacStore()
const userid = ref<string>()
const axios = container.resolve<Http>(CORE_AXIOS)

watch(
  () => rbac.$state.models.user, (state) => {
    userid.value = state[0].id as string
    adjustData.value.username = state[0].username || ''
    adjustData.value.rate = ''
    refreshData()
  }, {
  deep: true
}
)
onMounted(() => {
  const user = rbac.$state.models.user
  const sub_user = localStorage.getItem('user') || ""
  const userData = JSON.parse(sub_user).user
  adjustData.value.username = user[0].username || ''
  userid.value = user[0].id as string
  if (userData.isAdmin) {
    minRate.value = 0
  }
  refreshData()
})
const adjustData = ref({
  rate: '',
  username: ''
})
const minRate = ref(100)
const formRef = ref()
const addAdjust = () => {
  formRef.value.validate().then((res: any) => {
    if (res.outOfDate) {
      return
    }
    if (is_exsit.value) {
      axios.put('/v1/api/user/' + userid.value + '/sale/' + sale_id.value, { rate: adjustData.value.rate }).then(result => {
        message.success('保存成功')
      })
    } else {
      axios.post('/v1/api/user/' + userid.value + '/sale', { rate: adjustData.value.rate }).then(result => {
        message.success('保存成功')
      })
    }
  })
}
const is_exsit = ref<boolean>(false)
const sale_id = ref<number>(0)
// 刷新
const refreshData = () => {
  axios.get('/v1/api/user/' + userid.value + '/sale').then((result: any) => {
    // adjustData.value.rate = result
    if (result.createBy) {
      minRate.value = result.createBy.rate
    }
    if (result.sale) {
      adjustData.value.rate = result.sale.rate
      sale_id.value = result.sale.id
      is_exsit.value = true
    } else {
      is_exsit.value = false
    }
  })

}

</script>

<style lang="less" scoped>
:deep(.ant-input-number) {
  width: 100px;
  display: inline-block;
  margin-right: 10px;
}
</style>
